export default "__VITE_ASSET__bjxuKhvE__"